import type { PlanLink, PlanResponse } from "@Light/services/lightTypes";

/** The plan's `plan_links`, or the same list built from `links` when absent. */
export function getPlanLinks(
  rate: Pick<PlanResponse, "links" | "plan_links">,
): PlanLink[] {
  return (
    rate.plan_links ?? [
      {
        name: "Electricity Facts Label",
        short_name: "EFL",
        url: rate.links.efl,
      },
      {
        name: "Terms of Service",
        short_name: "Terms of Service",
        url: rate.links.tos,
      },
      {
        name: "Your Rights as a Customer",
        short_name: "YRAC",
        url: rate.links.yrac,
      },
    ]
  );
}
